import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import {
  FilterConfigType,
  TableColumn,
  TableComponent,
} from "@shared/components/table/table.component";
import {
  AuditLogs,
  AuditPermissionService,
} from "@core/services/audit-permission.service";
import { LazyLoadEvent } from "primeng/api";
import { Country } from "@core/services/api/api.service";
import { LoaderService } from "@core/services/gigya/loader/loader.service";
import { finalize } from "rxjs";
import { AddCountryComponent } from "./add-country/add-country.component";

@Component({
  selector: "app-country",
  imports: [TableComponent, AddCountryComponent],
  templateUrl: "./country.component.html",
  styleUrl: "./country.component.scss",
})
export class CountryComponent implements OnInit {
  countryData: Country[] = [];
  countryColumns: TableColumn[] = [];
  countryGlobalFilterFields: string[] = [];
  countryFiltersConfig: FilterConfigType[] = [];
  countryFiltersValue: { [key: string]: any } = {};
  openModal: boolean = false;

  countryActions: any[] = [];

  countryTotalRecords: number = 0;
  countryLoading: boolean = false;
  countryPage: number = 1;
  countryPageSize: number = 10;
  countryLastLazyLoadEvent: LazyLoadEvent | null = null;
  editData: any;
  editMode: boolean = false;
  constructor(
    private auditServices: AuditPermissionService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService
  ) {}
  ngOnInit(): void {
    this.setTabConfig();
    this.getCountries();
  }

  setTabConfig(): void {
    this.countryColumns = [
      { field: "sno", header: "S.No", sortable: false, width: "5%" },
      {
        field: "region_name",
        header: "Region Name",
        sortable: false,
        width: "10%",
      },
      {
        field: "name",
        header: "Country Name",
        sortable: false,
        filterable: false,
        width: "10%",
      },
      {
        field: "country_name",
        header: "",
        isAction: true,
      },
    ];

    this.countryActions = [
      {
        label: "Edit",
        class: "edit-button",
        onClick: (row: any) => this.editUser(row),
      },
    ];
  }

  editUser(row: any) {
    this.editData = row;
    this.editMode = true;
    this.openModal = true;
  }
  onLazyLoadEventFromTable(event: LazyLoadEvent) {
    this.countryLastLazyLoadEvent = event;
    this.countryLoading = true;
    this.loaderService.show();
    const currentEvent = event ||
      this.countryLastLazyLoadEvent || { first: 0, rows: this.countryPageSize };

    this.countryPage =
      (currentEvent.first ?? 0) / (currentEvent.rows ?? this.countryPageSize) +
      1;
    this.countryPageSize = currentEvent.rows ?? this.countryPageSize;
    this.getCountries();
  }

  getCountries() {
    this.auditServices
      .getCountries(this.countryPage, this.countryPageSize)
      .pipe(
        finalize(() => {
          this.countryLoading = false;
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: (response: any) => {
          this.countryData = response.countries.map(
            (item: Country, index: any) => ({
              ...item,
              sno: (this.countryPage - 1) * this.countryPageSize + index + 1,
              region_name: item.region.name,
            })
          );
          this.countryTotalRecords = response?.meta.total;
          this.cdr.detectChanges();
        },
        error: (error) => {},
      });
  }
  Add() {
    this.openModal = true;
  }
  closeDialog(event: any) {
    this.openModal = false;
    this.editMode = false;
    this.getCountries();
  }
}
